import { CourseLocation } from '../enums/course-location.enum';

export const COURSE_LOCATION_LABELS: Record<CourseLocation, string> = {
  [CourseLocation.PRESENTIAL]: 'Presencial',
  [CourseLocation.ONLINE]: 'Online',
  [CourseLocation.HYBRID]: 'Híbrido'
};
